import AddRemoveField from "../../../common/components/AddRemoveField.jsx";
import CounterField from "../../../common/components/CounterField.jsx";
import { Localization } from "../../../common/util/localization.jsx";
import { ProductViewListItem } from "../product/ProductViewListItem";
import PropTypes from "prop-types";
import React from "react";

/**
 * Returnerar Icon node med icon kod inkluderad
 * 
 * @param {object} props
 * @returns {node}
 */
export default function QueryResaultList({localization, productQuery, activeOrder, addRemoveProductToTemporaryOrder, border, setModal}) {
    const retNodes = [];

    for(let i=0; i<productQuery.resaults.length; i++){
        retNodes.push(
            <ProductViewListItem
                key={i}
                localization={localization}
                product={productQuery.resaults[i].product || {}}
                deviceType="xs"
                addRemoveProductToTemporaryOrder={addRemoveProductToTemporaryOrder}
                list={activeOrder}
                border={border}
                setModal={setModal}
                countingNode={activeOrder.name==null?<CounterField/>:<AddRemoveField/>}
            />
        );
    }

    return retNodes;
}

QueryResaultList.propTypes = {
    localization: Localization.propTypes.isRequired,
    productQuery: PropTypes.object.isRequired,
    addRemoveProductToTemporaryOrder: PropTypes.func.isRequired,
    activeOrder: PropTypes.object.isRequired,
    border: PropTypes.bool,
    setModal: PropTypes.func.isRequired,
};

QueryResaultList.defaultProps = {
    border: true,
};